import {
  Box,
  Breadcrumbs,
  Checkbox,
  Chip,
  Collapse,
  Dialog,
  IconButton,
  Link,
  Pagination,
  Typography,
} from "@mui/material";
import { bgcolors, colors, getNextPath, getParentPath, Node } from "./Utils";
import {
  ExpandMore,
  ChevronRight,
  Info,
  Edit,
  NavigateNextOutlined,
} from "@mui/icons-material";
import {
  columnCenter,
  displayColumn,
  displayRow,
  justifEnd,
  rowHorizontalEnd,
  rowHorizontalCenter,
} from "../../GlobalStyles";
import CountChips from "../../Components/AllCards/layouts/CountChips";
import CardFooter from "../../Components/AllCards/layouts/CardFooter";
import { chipConfigs } from "./Utils";
import ExamCard from "../../Components/AllCards/ExamCard";
import HoverCard from "./HoverCard";
import { convertFirstUpper } from "../../store/slices/constants/staticContents";
import { edit, eyeOpen } from "../../assets/svgs";
import { useRef, useState } from "react";
import { singleLineEllipsis } from "../../Components/AllCards/layouts/CardHeader";
import { useAppSelecter } from "../../hooks/storeHooks";
import { RootState } from "../../store/store";
import CustomProgress from "../../Components/CustomProgress";
import { ObjectValues } from "../login";
import BulkQuestionsForm from "../exams/BulkQuestionsForm";
import UpdatedQuestionPreviewWrapper from "../contentFeedback/UpdatedQuestionPreviewWrapper";
import ReportedQuestionPreview from "../contentFeedback/ReportedQuestionPreview";
import MessagePopper from "../contentFeedback/MessagePopper";
import globalColors from "../../globalColors";
import { MockLevelTypes } from "../../store/slices/detailedMaster/detailedMasterSlice";
import LinearWithValueLabel from "../../Components/LinearProgress";
import { iconText } from "../../Components/CustomTexts";
import QuestionDynamicPreviewDrawer from "./QuestionDynamicPreviewDrawer";

const ROOT_KEY = "__ROOT__";
const parentKey = (parentId: string | null) => parentId ?? ROOT_KEY;

export default function NodeItem({
  node,
  depth,
  parentId,
  selectedItems,
  onToggleSelect,
  expandedMap,
  onToggleExpand,
  headerDetail,
  cut,
  getFilteredList,
  onlyPreview,
  selectAll,
  fullscreen,
  setfullscreen,
  handleDeleteSingle,
  handleStatusSingle,
  hierarchy,
  setUpdate,
  update,
  onReFetch,
  setPagination,
  pagination,
  index,
  setQuestionPreviewOpen,
  questionPreviewOpen,
  lastMock,
}: {
  node: Node;
  depth: number;
  parentId: string | null;
  selectedItems: any;
  onToggleSelect: (id: string, level: MockLevelTypes) => void;
  expandedMap: Record<MockLevelTypes, string | null>;
  onToggleExpand: (
    type: MockLevelTypes,
    nodeId: string,
    parent: string
  ) => void;
  headerDetail: (data: any) => any;
  cut: any;
  getFilteredList: (list: Node[], type: MockLevelTypes) => any;
  onlyPreview: any;
  selectAll: boolean;
  fullscreen: any;
  setfullscreen: any;
  handleDeleteSingle: any;
  handleStatusSingle: any;
  hierarchy: any;
  setUpdate: any;
  update: any;
  onReFetch: (type: MockLevelTypes) => void;
  setPagination: React.Dispatch<React.SetStateAction<Record<number, any>>>;
  pagination: Record<MockLevelTypes, number | null>;
  index: number;
  setQuestionPreviewOpen: any;
  questionPreviewOpen: any;

  lastMock: any;
}) {
  const isFullscreen = fullscreen === `parent-${node.type}-${node.id}`;
  const rowPerPage = isFullscreen ? 8 : 5;
  const dialogRef = useRef({});
  const [isBulkQuestionDialogOpen, setIsBulkQuestionDialogOpen] = useState<{
    open: boolean;
    data?: ObjectValues;
  }>({ open: false });
  const handleBulkQuestionsSubmit = (questions: any) => {
    onReFetch("question");
    setIsBulkQuestionDialogOpen({ open: false });
  };
  const isLastMovedFroom =
    lastMock.length > 0
      ? lastMock.find((s: any) =>
          s && s[node.type] ? s[node.type].id === node.id : false
        )
      : false;

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const isSelected = selectedItems[node.type]
    ? (selectedItems[node.type] ?? []).includes(node.id)
    : node.type === "series"
    ? false
    : selectAll
    ? true
    : false;
  const { masters, mock_loading } = useAppSelecter(
    (state: RootState) => state.detailedMaster
  );
  const totalPages = Math.ceil(
    (
      getFilteredList(node?.children ?? [], getNextPath(node.type)) as Node[]
    ).filter((s) =>
      onlyPreview ? (selectedItems[s.type] ?? []).includes(s.id) : true
    ).length / rowPerPage
  );
  const currentPage =
    (pagination[getNextPath(node.type)] ?? 1) >
    Math.ceil(
      (
        getFilteredList(node?.children ?? [], getNextPath(node.type)) as Node[]
      ).filter((s) =>
        onlyPreview ? (selectedItems[s.type] ?? []).includes(s.id) : true
      ).length / rowPerPage
    )
      ? 1
      : pagination[getNextPath(node.type)] ?? 1;

  const myParentKey = parentKey(parentId);
  const isExpanded = expandedMap[node.type] === node.id;
  const details = node.details;
  const toggleExpand = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggleExpand(node.type, node.id, myParentKey);
    // setTimeout(() => {
    //   const scrollItem = document.getElementById(`${node.type}-${node.id}`); // your scrollable div
    //   const scrollParent = document.getElementById("treeScrollContainer");
    //   if (scrollItem && scrollParent) {
    //     const parentRect = scrollParent.getBoundingClientRect();
    //     const elemRect = scrollItem.getBoundingClientRect();
    //     // position of the item relative to parent scroll
    //     const offsetTop =
    //       scrollParent.scrollTop + (elemRect.top - parentRect.top);

    //     scrollParent.scrollTo({
    //       top: offsetTop,
    //       behavior: "smooth",
    //     });
    //   }
    // }, 1);
  };
  const getPaginated = (list: Node[]): Node[] => {
    return list.slice((currentPage - 1) * rowPerPage, currentPage * rowPerPage);
  };
  const child = (
    <>
      {/* {isBulkQuestionDialogOpen.open && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: "background.paper",
            zIndex: 1300,
          }}
        >
          <BulkQuestionsForm
            hierarchy={{
              ...hierarchy,
              [node.type.toLowerCase()]: node.label,
              [`${node.type.toLowerCase()}_id`]: node.id,
            }}
            subtopic={isBulkQuestionDialogOpen.data}
            dialogRef={dialogRef}
            onSubmit={handleBulkQuestionsSubmit}
            onClose={() => setIsBulkQuestionDialogOpen({ open: false })}
          />
        </Box>
      )} */}
      {(node.type === "mocktest" || node.type === "section") && isExpanded ? (
        ""
      ) : node.type === "series" && isExpanded ? (
        <Breadcrumbs
          separator={<NavigateNextOutlined fontSize="small" />}
          sx={{
            p: "0 10px",
            alignItems: "flex-end",
            ".MuiBreadcrumbs-separator": {
              fontSize: "0.75rem",
              color: globalColors.primary.normalText,
              margin: "10px",
            },
          }}
        >
          {iconText({
            key: `1`,
            // iconsx:"2px",
            // iconsx:!last&&{marginBottom:"4px"},
            text: node.label,
            icon: "",
            sx: {
              cursor: "pointer",
              color: globalColors.primary.purple,
              // first ? globalColors.primary.purple :
            },
            size: "0.75rem",
            onClick: toggleExpand,
            classname: "linkStyle-always",
          })}

          {expandedMap["mocktest"] &&
            node.children?.find((s) => s.id === expandedMap["mocktest"]) &&
            iconText({
              key: `1`,
              // iconsx:"2px",
              // iconsx:!last&&{marginBottom:"4px"},
              text:
                node.children?.find((s) => s.id === expandedMap["mocktest"])
                  ?.label ?? "",
              icon: "",
              sx: {
                cursor: "pointer",
                color: globalColors.primary.purple,
                // first ? globalColors.primary.purple :
              },
              size: "0.75rem",
              onClick: (e: any) => {
                e.stopPropagation();
                if (
                  node.children?.find((s) => s.id === expandedMap["mocktest"])
                ) {
                  onToggleExpand(
                    "mocktest",
                    expandedMap["mocktest"] ? expandedMap["mocktest"] : "",
                    node.id
                  );
                }
              },
              classname: "linkStyle-always",
            })}
          {expandedMap["section"] &&
            node.children
              ?.find((s) => s.id === expandedMap["mocktest"])
              ?.children?.find((s) => s.id === expandedMap["section"]) &&
            iconText({
              key: `1`,
              // iconsx:"2px",
              // iconsx:!last&&{marginBottom:"4px"},
              text:
                node.children
                  ?.find((s) => s.id === expandedMap["mocktest"])
                  ?.children?.find((s) => s.id === expandedMap["section"])
                  ?.label ?? "",
              icon: "",
              sx: {
                cursor: "pointer",
                color: globalColors.primary.purple,
                // first ? globalColors.primary.purple :
              },
              size: "0.75rem",
              onClick: (e: any) => {
                e.stopPropagation();
                if (
                  node.children
                    ?.find((s) => s.id === expandedMap["mocktest"])
                    ?.children?.find((s) => s.id === expandedMap["section"])
                ) {
                  onToggleExpand(
                    "section",
                    expandedMap["section"] ? expandedMap["section"] : "",
                    node.children?.find((s) => s.id === expandedMap["mocktest"])
                      ?.id ?? ""
                  );
                }
              },
              classname: "linkStyle-always",
            })}
          {iconText({
            key: `S`,
            // iconsx:"2px",
            // iconsx:!last&&{marginBottom:"4px"},
            text: `All${
              expandedMap["section"]
                ? `Questions (${
                    node.children
                      ?.find((s) => s.id === expandedMap["mocktest"])
                      ?.children?.find((s) => s.id === expandedMap["section"])
                      ?.children?.length
                  })`
                : !expandedMap["mocktest"]
                ? `Mocktests (${node.children?.length})`
                : `Sections (${
                    node.children?.find((s) => s.id === expandedMap["mocktest"])
                      ?.children?.length
                  })`
            }`,
            icon: "",
            sx: {
              cursor: "",
              color: globalColors.primary.normalText,
              // first ? globalColors.primary.purple :
            },
            size: "0.75rem",
            onClick: () => {},
            classname: "",
          })}
        </Breadcrumbs>
      ) : (
        <Box
          id={`${node.type}-${node.id}`}
          display="flex"
          alignItems="center"
          sx={{
            px: 1.5,
            py: 1,
            background: isExpanded
              ? bgcolors[node.type]
                ? bgcolors[node.type]
                : ""
              : "",
            borderRadius: "8px",
            opacity: cut && isSelected ? 0.4 : 1,
            cursor: isFullscreen ? "auto" : "pointer",
          }}
          onContextMenu={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setAnchorEl({
              e: e.currentTarget,
              node: node,
              axis: { mouseX: e.clientX - 2, mouseY: e.clientY - 4 },
            });
          }}
          onClick={
            isFullscreen
              ? undefined
              : node.type === "question"
              ? () => {
                  onToggleSelect(node.id, node.type);
                }
              : toggleExpand
          }
        >
          {/* {isFullscreen || node.type === "question" ? (
            ""
          ) : (
            <IconButton
              size="small"
              onClick={toggleExpand}
              aria-label={isExpanded ? "collapse" : "expand"}
            >
              {isExpanded ? (
                <ExpandMore fontSize="small" />
              ) : (
                <ChevronRight fontSize="small" />
              )}
            </IconButton>
          )} */}
          {/* ) : (
          <Box sx={{ width: 40, display: "inline-block" }} />
        )} */}

          {isFullscreen
            ? ""
            : node.type === "question" && (
                <>
                  <Checkbox
                    size="small"
                    checked={
                      (selectedItems[getNextPath(node.type)]
                        ? isSelected
                        : (selectedItems[node.type] ?? []).includes(node.id)
                        ? true
                        : false) || isSelected
                    }
                    // disabled={!showExpandicon?true:isExpanded}
                    onClick={(e) => {
                      e.stopPropagation();
                      onToggleSelect(node.id, node.type);
                    }}
                    sx={{ pl: "0" }}
                  />
                  <Typography
                    sx={{ color: "#6B7280", fontSize: "12px", mr: "3px" }}
                  >
                    {node.type === "question" ? `Q.${index + 1}` : ""}
                  </Typography>
                </>
              )}
          <Box
            sx={{
              flexDirection: "column",
              display: "flex",
              width: "fit-content",
              gap: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box sx={{ display: "flex" }}>
                {" "}
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, color: "#0f1729", fontSize: "13px" }}
                >
                  {node.type === "question" ? (
                    <div
                      style={{
                        // minHeight: "49.54px",
                        maxWidth: "400px",
                        cursor: "pointer",
                        maxHeight: "fit-content",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setQuestionPreviewOpen({ node, hierarchy });
                      }}
                    >
                      <Box
                        sx={{
                          height: "49.54px",
                          maxHeight: "fit-content",
                        }}
                      >
                        <MessagePopper
                          color={
                            questionPreviewOpen?.node?.id === node.id
                              ? "black"
                              : undefined
                          }
                          text={node.details.text ?? ""}
                          type="ck"
                          id={"question"}
                        />
                      </Box>
                    </div>
                  ) : isFullscreen ? (
                    (() => {
                      const hierarchyOrder = [
                        "exam",
                        "goal",
                        "section",
                        "unit",
                        "topic",
                        "subtopic",
                        "cluster",
                      ];
                      let parts: string[] = [];
                      for (const key of hierarchyOrder) {
                        if (hierarchy[key]) {
                          parts.push(hierarchy[key]);
                        } else {
                          // Stop at the first missing and add node.label
                          parts.push(node.label);
                          break;
                        }
                      }
                      // If all are present, still add node.label at the end
                      if (
                        parts.length === hierarchyOrder.length &&
                        parts[parts.length - 1] !== node.label
                      ) {
                        parts.push(node.label);
                      }
                      return parts.join(" • ");
                    })()
                  ) : (
                    node.label
                  )}
                </Typography>
                {isLastMovedFroom ? (
                  <Typography
                    ml="10px"
                    variant="body2"
                    sx={{ fontWeight: 500, color: "green", fontSize: "13px" }}
                  >
                    ( Last tagged )
                  </Typography>
                ) : (
                  ""
                )}
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Chip
                  label={`id: #${node.id}`}
                  size="small"
                  sx={{
                    border: "none",
                    borderRadius: "4px",
                    padding: "0",
                    color: "rgb(0 0 0 / 60%)",
                    fontSize: "0.75rem",
                    background: "transparent",
                    "& .MuiChip-label": {
                      padding: "0 3px !important",
                    },
                    ...singleLineEllipsis,
                  }}
                />
                {node.status && (
                  <Box
                    sx={{
                      borderRadius: "8px",
                      padding: "6px 10px",
                      background:
                        globalColors.colorCombinations[node.status]?.bg ?? "",
                      color:
                        globalColors.colorCombinations[node.status]?.color ??
                        "",
                      textTransform: "capitalize",
                      ...rowHorizontalCenter,
                      // minWidth: "fit-content",
                      maxWidth: "100%",
                      fontSize: "0.75rem",
                      lineHeight: "normal",
                      textOverflow: "ellipsis",
                      whiteSpace: "normal",
                      overflow: "hidden",
                      width: "fit-content",
                    }}
                  >
                    {convertFirstUpper(node.status)}
                  </Box>
                )}
              </Box>
            </Box>
            {/* <Box>Tagged Progress</Box> */}
          </Box>
          <Box sx={{ display: "flex", flex: 8, justifyContent: "flex-end" }}>
            <Box
              sx={{
                flexDirection: "column",
                display: "flex",
                width: "fit-content",
                gap: "5px",
              }}
            >
              <Box
                sx={{
                  ml: "auto",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Box sx={{ gap: "8px", ...displayRow, ...justifEnd }}>
                  {chipConfigs(details).map((chip: any) => (
                    <Box
                      key={chip.key}
                      sx={{ maxWidth: "102px !important", width: "auto" }}
                    >
                      <CountChips
                        label={chip.label}
                        value={chip.value}
                        color={chip.color}
                        text={chip.text}
                      />
                    </Box>
                  ))}
                  <Box
                    sx={{
                      maxWidth: "fit-content",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {
                      <HoverCard
                        icon={
                          <Info
                            sx={{
                              color: "#9ca3af",
                              height: "16px",
                              width: "16px",
                            }}
                          />
                        }
                        content={
                          <CardFooter
                            internal_remark={details.internal_remark}
                            created_at={details.created_at}
                            created_by_id={details.created_by_id}
                            modified_at={details.modified_at}
                            modified_by_id={details.modified_by_id}
                          />
                        }
                      />
                    }
                  </Box>{" "}
                  {node.type === "question" ? (
                    <Box
                      sx={{ cursor: "pointer", p: "2px", ...columnCenter }}
                      onClick={() => {
                        setUpdate({
                          node: node,
                          hierarchy: hierarchy,
                          parent: parentId,
                        });
                      }}
                    >
                      {edit}
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
              {details.total_questions && (
                <Box sx={{ ml: "auto", width: "100%" }}>
                  {node.type === "series" && expandedMap["series"] ? (
                    ""
                  ) : (
                    <LinearWithValueLabel
                      value={details.total_reviewed_questions}
                      total={details.total_questions}
                    />
                  )}
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
      {isExpanded && (
        <Box
          sx={
            isFullscreen
              ? {
                  flex: 8,
                  ...displayColumn,
                  background: "#F4F5FA",
                  height: "calc(100dvh - 66px)",
                }
              : node.type !== "question" && isExpanded
              ? {
                  flex: 8,
                  width: "100%",
                  background: "#F4F5FA",
                  flexGrow: 8,
                  maxHeight:
                    (node.type === "mocktest" || node.type === "section") &&
                    isExpanded
                      ? "100%"
                      : "calc(100% - 40px)",
                  boxSizing: "border-box",
                  // p: "2px 10px",
                }
              : {
                  background: "#F4F5FA",
                }
          }
        >
          <Collapse
            in={isExpanded}
            timeout="auto"
            unmountOnExit
            sx={
              isFullscreen || (node.type !== "question" && isExpanded)
                ? {
                    height: "100% !important",
                    "& .MuiCollapse-wrapper": { height: "100% !important" },
                  }
                : {}
            }
          >
            <Box
              sx={
                isFullscreen || (node.type !== "question" && isExpanded)
                  ? { height: "100%", ...displayColumn }
                  : {}
              }
            >
              {node.type === "section"
                ? headerDetail({ node, parentId, onToggleExpand, isFullscreen })
                : node.type === "mocktest"
                ? expandedMap["mocktest"]
                  ? expandedMap["mocktest"] === (node?.id ?? "")
                    ? ""
                    : headerDetail({
                        node,
                        parentId,
                        onToggleExpand,
                        isFullscreen,
                      })
                  : headerDetail({
                      node,
                      parentId,
                      onToggleExpand,
                      isFullscreen,
                    })
                : node.type === "series" && expandedMap["series"]
                ? ""
                : headerDetail({
                    node,
                    parentId,
                    onToggleExpand,
                    isFullscreen,
                  })}
              {mock_loading[
                `${getNextPath(node.type)}` as keyof typeof mock_loading
              ] ||
              mock_loading[
                `${
                  node?.children
                    ? getNextPath(node.type).toLowerCase()
                    : node?.type.toLowerCase()
                }` as keyof typeof mock_loading
              ] ? (
                <Box
                  sx={{
                    width: "100%",
                    flex: 8,
                    minHeight: "100px",
                    ...columnCenter,
                  }}
                >
                  <CustomProgress
                    sx={{
                      height: "50px !important",
                      width: "50px !important",
                      color: "black !important",
                    }}
                  />
                </Box>
              ) : (
                ""
              )}
              {node.children && node.children.length > 0 ? (
                <Box
                  className="scrollBluePrimarythin"
                  sx={
                    isFullscreen || (node.type !== "question" && isExpanded)
                      ? { width: "100%", flex: 8, overflowY: "auto" }
                      : {}
                  }
                >
                  {(
                    getFilteredList(
                      node.children,
                      getNextPath(node.type)
                    ) as Node[]
                  ).filter((s) =>
                    onlyPreview
                      ? (selectedItems[s.type] ?? []).includes(s.id)
                      : true
                  ).length > 0 ? (
                    getPaginated(
                      (
                        getFilteredList(
                          node.children,
                          getNextPath(node.type)
                        ) as Node[]
                      ).filter((s) =>
                        onlyPreview
                          ? (selectedItems[s.type] ?? []).includes(s.id)
                          : true
                      )
                    )
                      .filter((s) =>
                        s.type === "section"
                          ? expandedMap["section"]
                            ? expandedMap["section"] === (s?.id ?? "")
                            : true
                          : s.type === "mocktest"
                          ? expandedMap["mocktest"]
                            ? expandedMap["mocktest"] === (s?.id ?? "")
                            : true
                          : true
                      )
                      .map((child: Node, index: number) => (
                        <NodeItem
                          onReFetch={onReFetch}
                          lastMock={lastMock}
                          setQuestionPreviewOpen={setQuestionPreviewOpen}
                          questionPreviewOpen={questionPreviewOpen}
                          setPagination={setPagination}
                          index={
                            child.type === "question" && node && node.children
                              ? (
                                  getFilteredList(
                                    node?.children,
                                    getNextPath(node.type)
                                  ) as Node[]
                                ).findIndex((s) => s.id === child.id)
                              : index
                          }
                          pagination={pagination}
                          hierarchy={{
                            ...hierarchy,
                            [node.type.toLowerCase()]: node.label,
                            [`${node.type.toLowerCase()}_id`]: node.id,
                          }}
                          setUpdate={setUpdate}
                          update={update}
                          handleDeleteSingle={handleDeleteSingle}
                          handleStatusSingle={handleStatusSingle}
                          getFilteredList={getFilteredList}
                          key={child.id}
                          fullscreen={fullscreen}
                          setfullscreen={setfullscreen}
                          node={child}
                          depth={depth + 1}
                          parentId={node.id}
                          selectAll={
                            selectedItems[child.type]
                              ? false
                              : (selectedItems[node.type] ?? []).includes(
                                  node.id
                                ) || selectAll
                              ? true
                              : false
                          }
                          onlyPreview={onlyPreview}
                          selectedItems={selectedItems}
                          onToggleSelect={onToggleSelect}
                          expandedMap={expandedMap}
                          onToggleExpand={onToggleExpand}
                          headerDetail={headerDetail}
                          cut={cut}
                        />
                      ))
                  ) : (
                    <Box
                      sx={{ width: "100%", height: "100px", ...columnCenter }}
                    >
                      No data found
                    </Box>
                  )}
                </Box>
              ) : mock_loading[
                  `${getNextPath(node.type)}` as keyof typeof mock_loading
                ] ||
                mock_loading[
                  `${
                    node?.children
                      ? getNextPath(node.type).toLowerCase()
                      : node?.type.toLowerCase()
                  }` as keyof typeof mock_loading
                ] ? (
                ""
              ) : (
                <Box sx={{ width: "100%", ...columnCenter, flex: 8 }}>
                  No data found
                </Box>
              )}
              {node.children && node.children.length > 0 ? (
                totalPages > 1 ? (
                  expandedMap[getNextPath(node.type)] ? (
                    ""
                  ) : (
                    <Box sx={{ ...rowHorizontalEnd, width: "100%" }}>
                      <Pagination
                        showFirstButton
                        showLastButton
                        defaultPage={currentPage}
                        page={currentPage}
                        count={totalPages}
                        onChange={(event: any, newPage: number) => {
                          setPagination((prev) => {
                            return {
                              ...prev,
                              [getNextPath(node.type)]: newPage,
                            };
                          });
                        }}
                      />
                    </Box>
                  )
                ) : (
                  ""
                )
              ) : (
                ""
              )}
            </Box>
          </Collapse>
        </Box>
      )}
    </>
  );
  return isFullscreen ? (
    <Dialog
      open={true}
      sx={{
        "& .MuiDialog-paper": {
          margin: "0",
          minHeight: "100dvh",
          minWidth: "100%",
          height: "100dvh",
          borderRadius: 0,
        },
      }}
      fullScreen={true}
      TransitionProps={{ timeout: 400 }}
    >
      {child}
    </Dialog>
  ) : (
    <Box
      sx={
        isFullscreen
          ? {
              height: "100dvh",
              position: "fixed",
              top: 0,
              left: 0,
              zIndex: 9999,
              width: "100%",
              background: "#FFFFFF",
              minWidth: "100%",
              transition: "all 0.4s ease-in-out", // smoothness
            }
          : (node.type === "series" ||
              node.type === "mocktest" ||
              node.type === "section") &&
            isExpanded
          ? {
              width: "100%",
              height: "100%",
              ...displayColumn,
              borderRadius: "8px",
            }
          : {
              // border: `1px solid ${colors[node.type] ? colors[node.type] : ""}`,
              m: node?.type === "series" ? "5px 5px 10px" : "10px",

              maxWidth: depth ? "calc(100% - 16px)" : "100%",
              boxSizing: "border-box",
              background: "#FFFFFF",
              border: "1px solid #e5e7eb",
              "&:hover": {
                boxShadow: 4,
                transform: "scale(1.01)",
                // border: "2px dashed #519C66",
              },
              borderRadius: "8px",

              transition: "all 0.4s ease-in-out", // smoothness
            }
      }
      id={`parent-${node.type}-${node.id}`}
    >
      {child}
    </Box>
  );
}
